type PortraitTileProps = {
  src: string;
  alt: string;
  area?: "portrait" | "contact";
};

function PortraitTile({ src, alt, area = "portrait" }: PortraitTileProps) {
  const areaClass =
    area === "contact" ? "bentolio-area-contact" : "bentolio-area-portrait";

  return (
    <section className={areaClass}>
      <img src={src} alt={alt} className="portrait-image" />
    </section>
  );
}

export default PortraitTile;
